/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_6_DescInputs */

const en_mk_feature_6_desc = /** @type {(inputs: Mk_Feature_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move plans between tools, export documents, and connect agents through CLI, MCP, or API.`)
};

const id_mk_feature_6_desc = /** @type {(inputs: Mk_Feature_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa rencana ke alat lain, ekspor dokumen, dan hubungkan agent lewat CLI, MCP, atau API.`)
};

/**
* | output |
* | --- |
* | "Move plans between tools, export documents, and connect agents through CLI, MCP, or API." |
*
* @param {Mk_Feature_6_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_6_desc = /** @type {((inputs?: Mk_Feature_6_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_6_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_6_desc(inputs)
	return en_mk_feature_6_desc(inputs)
});